




























































import {
  Component,
  Vue,
  Prop,
  Watch,
  Provide,
  Emit
} from "vue-property-decorator";
import {
  State,
  Mutation
} from "vuex-class";

import bpui from 'bpui.js';
import customDialog from './customDialog.vue';

@Component({
  components: {
    bpDialog: bpui.bpDialog,
  }
})
export default class extends Vue {
  //
  // event.
  @Emit()
  demoEvent(type: string) {}

  //
  // state.
  // @State(state=>state.demo) demo:DEMO_TYPE;

  //
  // Prop
  // @Prop({ type: number }) demo: number;

  //
  // data.
  @Provide() visible1:boolean = false;
  @Provide() visible2:boolean = false;
  @Provide() visible3:boolean = false;
  

  //
  // computed.
  // get demo() { return xxxx; }

  //
  // watch.
  // @Watch('child')
  // onChildChanged(val: string, oldVal: string) { }

  //
  // lifecycle hook.
  constructor() {
    super();
    bpui.hook.addWidgetShake((paddingRight)=>{
      console.log("widget shake: " + paddingRight);
    })
  }

  showAlert():void {
    // @ts-ignore
    this.$bpWidget.showAlert({content:'aaaa', confirm:(id)=>{
      // @ts-ignore
      this.$bpWidget.hideAlert(id);
    }})
  }

  showConfirm():void {
    // @ts-ignore
    this.$bpWidget.showConfirm({content:'确定取消?', cancel:(id)=>{
      // @ts-ignore
      this.$bpWidget.hideConfirm(id);
    }, confirm:(id)=>{
      // @ts-ignore
      this.$bpWidget.showAlert('确认');
    }})
  }
  
  showLoading():void {
    // @ts-ignore
    this.$bpWidget.showLoading('hide in 4s');
    this.$timer.sleep(1000)
                // @ts-ignore
               .then(()=>{ this.$bpWidget.showLoading('hide in 3s'); })
               .then(()=>this.$timer.sleep(1000))
               // @ts-ignore
               .then(()=>{ this.$bpWidget.showLoading('hide in 2s'); })
               .then(()=>this.$timer.sleep(1000))
               // @ts-ignore
               .then(()=>{ this.$bpWidget.showLoading('hide in 1s'); })
               .then(()=>this.$timer.sleep(1000))
               // @ts-ignore
               .then(()=>{ this.$bpWidget.hideLoading(); });
  }
  
  showCustom():void {
    bpui.registerDialogCustom("test", customDialog);
    let dialogId = bpui.apiWidget.showCustom("test", {props: {title:'will close in 5s'}});

    setTimeout(()=>{
      bpui.apiWidget.hideCustom(dialogId);
    }, 5000);
  }
}
